export default {
  aigc_upload_resource_upload: "资源上传",
  aigc_upload_resource_edit: "编辑资源",
  aigc_upload_name: "工具/案例名称",
  aigc_upload_name_tips: "请输入工具/案例名称",
  aigc_upload_website: "网址",
  aigc_upload_website_tips: "请输入网址",
  aigc_upload_internal: "内部可用",
  aigc_upload_tool_case: "工具/案例",
  aigc_upload_tool: "工具",
  aigc_upload_case: "案例",
  aigc_upload_type: "工具/案例类型",
  aigc_upload_type_tips: "请选择工具/案例类型",
  aigc_upload_application: "应用场景",
  aigc_upload_application_tips: "请选择应用场景",
  aigc_upload_description: "简介",
  aigc_upload_description_tips: "请输入简介",
  aigc_upload_screenshot: "补充说明截图",
  aigc_upload_detailed_description: "详细描述",
  aigc_upload_detailed_description_tips: "请描述工具的用途、场景和案例",
  aigc_upload_content: "请描述工具的用途、场景和案例",
  aigc_upload_submit: "提交",
  aigc_upload_click: "点击上传",
  aigc_upload_drag: "拖拽到此区域",
  aigc_upload_drag_tips: "请上传 jpg/png 格式文件，大小 1MB 以内",
  aigc_upload_drag_tips2: "请上传 json/csv 格式文件，大小 1MB 以内",
  aigc_upload_file_size: "文件大小",
  aigc_upload_file_day: "上传日期",
  aigc_upload_file_reupload: "重新上传",
  aigc_upload_file_cancel: "取消上传",
  aigc_upload_file_delete: "删除",
  aigc_upload_submit_success: "提交成功",
  aigc_upload_submit_error: "提交失败",
  aigc_upload_submit_warning: "正在上传图片, 请稍后提交",
  aigc_upload_edit_success: "更改成功",
  aigc_upload_edit_error: "更改失败",
};